import React from "react";
import moment from "../../../moment";
import DateRangePicker from "../../DateRangePicker";
import FilterDropdownButtons from "./FilterDropdownButtons";

export const getColumnDateFilterProps = ({ tableParams = {}, column = {} }) => {
  const filterColumn = tableParams.filters?.filter((item) => item.column === column.dataIndex);
  const filterValue =
    filterColumn.length > 0 ? [moment(filterColumn[0].value), moment(filterColumn[1].value)] : undefined;

  const onChange = (setSelectedKeys) => (val) => {
    setSelectedKeys(val);
  };

  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
      <div className="table-filter-dropdown filter-range-date-picker">
        <DateRangePicker
          size="medium"
          value={selectedKeys}
          onChange={onChange(setSelectedKeys)}
          onPressEnter={() => confirm()}
        />
        <FilterDropdownButtons confirm={confirm} />
      </div>
    ),
    filteredValue: filterValue || null
  };
};
